import React,{useState,useEffect} from 'react'
import { invokeHolidays } from '../../ServiceCalls/ApiCalls';
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { PropagateLoader } from 'react-spinners';
import 'react-toastify/dist/ReactToastify.css';
import '../SquadInfo/SquadInfo.css'; // Reuse the same CSS styles

function ManageHolidays() {
  
  const navigate = useNavigate()
  const[startDate,setStartDate] = useState('')
  const[endDate,setEndDate] = useState('')
  const[desc,setDesc] = useState('')
  const[status,setStatus]=useState(false)
  const[isLoading,setIsLoading]=useState(false)
  const[isRefreshing,setIsRefreshing]=useState(false)
  const[holidays,setHolidays] = useState([])
  const[createHoliday,setCreateHoliday] = useState({
    startDate:'',
    endDate:'',
    desc:''
})

  useEffect(() =>{
    if(!localStorage.getItem('user')){
        navigate('/')
    }
    async function GetData(){
        setIsLoading(true)
        try {
            const holidays_list = await invokeHolidays()
            setHolidays(holidays_list)
        } catch (error) {
            console.error('Error fetching holidays:', error)
            toast.error('Failed to load holidays')
        } finally {
            setIsLoading(false)
        }
    }

    GetData()
  },[])

  const handleHolidayChange = (e) => {
        e.preventDefault()

        const{name,value} = e.target;

        if(name === 'startDate'){
            setStartDate(value)
        }
        
        if(name === 'endDate'){
            setEndDate(value)
        }
        
        if(name === 'desc'){
            setDesc(value)
        }
  }

  const handleCreateHoliday = (e) => {
    const{name,value} = e.target;
    setCreateHoliday({...createHoliday,[name]:value})

  }

  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
 }
  const reset = (e) => {
    e.preventDefault()
    setCreateHoliday({
        startDate:'',
        endDate:'',
        desc:''
    })
}

  const handleEditHoliday = (h,rid) =>{

  }

  const deleteHoliday = async(id,rid) => {
    
    if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rid+1}`))
        return;

    try{
        const delete_holiday_response = await fetch(`${URL}` + '/holiday/'+`${id}`, options("DELETE"));
        if(delete_holiday_response.ok){
        // alert(`TermDate at ${rowid+1}  is Deleted !!`)
            const dataDelete = [...holidays];
            dataDelete.splice(rid,1)
            setHolidays([...dataDelete])
            toast.success('🦄 Wow Holiday Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });

        }
        else{
            toast.error('🦄 OOps Holiday Del Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }catch(err){
        console.log(err)
    }
  }

  const handleSubmitHolidays = async(e) =>{
        e.preventDefault()

        try {
            const add_holidays_response = await fetch(`${URL}` + '/holiday/addholiday',options("POST",createHoliday));
            const holidays_data = await add_holidays_response.json();

            if(add_holidays_response.ok){
                //alert('Term Dates Added !!')
                setHolidays([...holidays,holidays_data])
                toast.success('🦄 Wow Holiday Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Add Holiday Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            console.log(error)
        }
  }

  const handleUpdateHolidays = () => {

  }

  const refreshHolidays = async () => {
    setIsRefreshing(true)
    try {
        const holidays_list = await invokeHolidays()
        setHolidays(holidays_list)
        toast.success('Holidays refreshed successfully!')
    } catch (error) {
        console.error('Error refreshing holidays:', error)
        toast.error('Failed to refresh holidays')
    } finally {
        setIsRefreshing(false)
    }
  }

  return (
    <div className='admin-panel'>
      <div className="container admin-container">
        {/* Header Section */}
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
              <div>
                <h3 className="mb-1">
                  <i className="fa fa-calendar-times text-warning me-2"></i>
                  Manage Holidays
                </h3>
                <p className="text-muted">
                  Add and manage holiday periods when courts are unavailable
                </p>
                <span className="badge bg-primary">
                  <i className="fa fa-calendar me-1"></i>
                  {holidays.length} {holidays.length === 1 ? 'Holiday' : 'Holidays'}
                </span>
              </div>
              <div className="header-actions">
                <button
                  onClick={refreshHolidays}
                  disabled={isRefreshing}
                  className="btn btn-outline-primary me-2">
                  {isRefreshing ? (
                    <PropagateLoader size={8} color="#007bff" />
                  ) : (
                    <>
                      <i className="fa fa-refresh me-2"></i>
                      Refresh
                    </>
                  )}
                </button>
                <button
                  onClick={() => navigate('/user')}
                  className="btn btn-outline-secondary">
                  <i className="fa fa-arrow-left me-2"></i>
                  Back to Dashboard
                </button>
              </div>
            </div>
            </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-content">
              <PropagateLoader size={15} color="#007bff" />
              <p className="loading-text">Loading holidays...</p>
                </div>
          </div>
        ) : (
          <>
            {/* Add Holiday Section */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-plus text-success me-2"></i>
                      Add New Holiday Period
                    </h5>
        </div>
                  <form onSubmit={handleSubmitHolidays} className="holiday-form">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="startDate" className="form-label">
                          <i className="fa fa-calendar text-primary me-2"></i>
                          Start Date
                        </label>
                        <input
                          type="date"
                          name="startDate"
                          className="form-control" 
                          value={createHoliday.startDate}
                          onChange={e => handleCreateHoliday(e)}
                          id="startDate"
                          required />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="endDate" className="form-label">
                          <i className="fa fa-calendar text-success me-2"></i>
                          End Date
                        </label>
                        <input
                          type="date"
                          name="endDate"
                          className="form-control" 
                          value={createHoliday.endDate}
                          onChange={e => handleCreateHoliday(e)}
                          id="endDate"
                          required />
                      </div>
                      <div className="col-12 mb-3">
                        <label htmlFor="desc" className="form-label">
                          <i className="fa fa-file-text text-info me-2"></i>
                          Description
                        </label>
                        <textarea 
                          className="form-control" 
                          id="desc" 
                          name="desc"
                          rows={4}
                          value={createHoliday.desc} 
                          onChange={e => handleCreateHoliday(e)} 
                          required
                          placeholder="Enter holiday description (e.g., Christmas Break, New Year Holiday)"
                          autoComplete='off'/>
                      </div>
                    </div>
                    <div className="form-actions">
                      <button 
                        type="submit" 
                        className="btn btn-primary me-2">
                        <i className="fa fa-plus me-2"></i>
                        Add Holiday
                      </button>
                      <button 
                        type="button"
                        onClick={e => reset(e)}
                        className="btn btn-outline-secondary">
                        <i className="fa fa-refresh me-2"></i>
                        Reset Form
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Existing Holidays Section */}
            <div className="row">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-list text-info me-2"></i>
                      Existing Holidays
                    </h5>
                  </div>
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th>S.No</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {holidays.length > 0 ? (
                                holidays.map((h,idx) => (
                                  <tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>
                                      <i className="fa fa-calendar text-primary me-1"></i>
                                      {h.startDate}
                                    </td>
                                    <td>
                                      <i className="fa fa-calendar text-success me-1"></i>
                                      {h.endDate}
                                    </td>
                                    <td>
                                      <span className="text-muted">{h.desc || 'No description'}</span>
                                    </td>
                                    <td className="text-center">
                                      <button
                                        type="button"
                                        onClick={() => deleteHoliday(h._id,idx)}
                                        className="btn btn-sm btn-outline-danger"
                                        title="Delete Holiday">
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} className="text-center py-4">
                                    <div className="empty-state">
                                      <i className="fa fa-calendar-times fa-3x text-muted mb-3"></i>
                                      <h5 className="text-muted">No Holidays Found</h5>
                                      <p className="text-muted">Add your first holiday period using the form above.</p>
                                    </div>
                                  </td>
                                </tr>
                              )
                            }
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Edit Modal */}
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">Edit Holiday</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        data-bs-dismiss="modal" 
                  aria-label="Close">
                </button>
                                </div>
                                <div className="modal-body">
                {status ? (
                                            <div className="container">
                                                <div className="row my-3">
                                                    <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                                         <div className="success-img"></div>
                                                        <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                                    </div>
                                                </div>
                                            </div>
                ) : (
                                            <div className="container">
                                            <div className="row my-3">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="startDate" className="small"><strong>StartDate</strong></label>
                                                    <input 
                                                        type="date"
                                                        className='form-control service'
                                                        name="startDate"
                                                        value={startDate}
                                                        onChange={e => handleHolidayChange(e)}
                                                        autoComplete='off'
                                                        id="startDate" />
                                                </div>  
                                            </div>
                                            <div className="row my-3">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="EndDate" className="small"><strong>EndDate</strong></label>
                                                    <input 
                                                        type="date"
                                                        className='form-control service'
                                                        name="EndDate"
                                                        value={endDate}
                                                        onChange={e => handleHolidayChange(e)}
                                                        autoComplete='off'
                                                        id="EndDate" />
                                                </div>  
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="desc" className="small"><strong>Holiday Desc</strong></label>
                                                    <textarea 
                                                        name="desc"
                                                        className='form-control service'
                                                        id="desc"
                                                        rows={5}
                                                        value={desc}
                                                        autoComplete='off'
                                                        onChange = {e => handleHolidayChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                )}
                                </div>
                                <div className="modal-footer">
                {status ? (
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                    data-bs-dismiss="modal">
                    Close
                  </button>
                ) : (
                                        <button 
                                            onClick={() => handleUpdateHolidays()}
                                            type="button" 
                    className="btn btn-primary">
                    Update
                  </button>
                )}
              </div>
                                </div>
                            </div>
                        </div>
                </div>
        <ToastContainer/>
    </div>
  )
}

export default ManageHolidays